var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.0771 9.76758H8.11163C6.65161 9.76758 5.46802 10.9512 5.46802 12.4112V24.3075C5.46802 25.7675 6.65161 26.9511 8.11163 26.9511H20.0079C21.4679 26.9511 22.6515 25.7675 22.6515 24.3075V20.342",
    stroke: "#8B909A",
    strokeWidth: 2.31316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M12.077 20.3424H16.0425L27.2778 9.107C28.3728 8.01198 28.3728 6.2366 27.2778 5.14158C26.1828 4.04656 24.4074 4.04656 23.3124 5.14158L12.077 16.377V20.3424",
    stroke: "#8B909A",
    strokeWidth: 2.31316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M21.3297 7.125L25.2951 11.0904",
    stroke: "#8B909A",
    strokeWidth: 2.31316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerEdit);
export default __webpack_public_path__ + "static/media/customer_edit.437569e16e4df1c5c279e65432e1e9cf.svg";
export { ForwardRef as ReactComponent };